/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_History1Inputs */

const vi_driverremittance_history1 = /** @type {(inputs: Driverremittance_History1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử nộp quỹ`)
};

/**

* @param {Driverremittance_History1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_history1 = /** @type {((inputs?: Driverremittance_History1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_History1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_history1(inputs)
});
export { driverremittance_history1 as "driverRemittance_history" }